var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983 624L983 652",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 983.5,
    cy: 619.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M980.105 628C979.637 628 979.236 627.834 978.903 627.501C978.57 627.168 978.403 626.768 978.403 626.3C978.403 625.833 978.57 625.432 978.903 625.099C979.236 624.766 979.637 624.6 980.105 624.6C980.573 624.6 980.973 624.766 981.306 625.099C981.64 625.432 981.806 625.833 981.806 626.3C981.806 626.768 981.64 627.168 981.306 627.501C980.973 627.834 980.573 628 980.105 628ZM988.613 628C988.145 628 987.744 627.834 987.411 627.501C987.078 627.168 986.911 626.768 986.911 626.3C986.911 625.833 987.078 625.432 987.411 625.099C987.744 624.766 988.145 624.6 988.613 624.6C989.081 624.6 989.481 624.766 989.814 625.099C990.148 625.432 990.314 625.833 990.314 626.3C990.314 626.768 990.148 627.168 989.814 627.501C989.481 627.834 989.081 628 988.613 628ZM979.382 614.4L981.423 618.65H987.379L989.719 614.4H979.382ZM978.573 612.7H991.122C991.449 612.7 991.697 612.845 991.867 613.136C992.037 613.426 992.044 613.72 991.888 614.018L988.868 619.457C988.712 619.741 988.503 619.96 988.24 620.116C987.978 620.272 987.691 620.35 987.379 620.35H981.041L980.105 622.05H990.314V623.75H980.105C979.467 623.75 978.985 623.47 978.658 622.911C978.332 622.351 978.318 621.795 978.616 621.242L979.764 619.16L976.702 612.7H975V611H977.765L978.573 612.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping2);
export default __webpack_public_path__ + "static/media/shopping_2.36b9c3a336e663c234e4d1390cab56e9.svg";
export { ForwardRef as ReactComponent };